<template>
    <v-form ref="formDados"
        lazy-validation
        v-model="formValid">
            <v-container fluid>
                <v-card>
                    <v-card-title>
                       <h3>Gerenciar formas de trabalho</h3>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col :cols="dynamicCol">
                              <v-autocomplete
                                v-model="IdUnidadeSelecionado"
                                :items="unidadesList"
                                item-text="Unidade"
                                item-value="IdUnidade"
                                label="Unidade"
                                @change="[getAllData($event)]"
                                hide-details
                                outlined
                                dense
                                clearable
                              ></v-autocomplete>
                            </v-col>
                            <v-col :cols="dynamicCol">
                              <v-autocomplete
                                  v-model="IdEspecialidadeSelecionada"
                                  :items="especialidadesList"
                                  item-text="Especialidade"
                                  item-value="IdEspecialidade"
                                  label="Especialidade"
                                  @change="[getAllData($event)]"
                                  hide-details
                                  outlined
                                  dense
                                  clearable
                              ></v-autocomplete>
                            </v-col>
                            <v-col :cols="dynamicCol">
                              <v-select
                                  v-model="IdPeriodoSelecionada"
                                  :items="periodosList"
                                  item-text="Periodo"
                                  item-value="IdPeriodo"
                                  label="Período"
                                  @change="[getAllData($event)]"
                                  hide-details
                                  outlined
                                  dense
                                  clearable
                              ></v-select>
                            </v-col>
                            <v-col
                                cols="3"
                                v-if="IdEspecialidadeSelecionada != null || IdUnidadeSelecionado != null || IdPeriodoSelecionada != null"
                            >
                              <v-btn
                                  class="mt-3 "
                                  color="primary"
                                  block
                                  @click="[limparFiltros(), getAllData($event)]"
                                  dark
                              >
                                Limpar Filtros
                              </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="9">
                                <v-text-field v-model="search" prepend-icon="mdi-feature-search-outline" label="Pesquisar" clearable></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-btn block color="primary" class="mt-3" @click="dialogCadFormaTrabalho = !dialogCadFormaTrabalho" dark>
                                    <v-icon left>mdi-calendar-plus</v-icon>
                                    Nova forma de trabalho
                                </v-btn>
                            </v-col>                    
                        </v-row>
                        <v-data-table
                            :headers="headers"
                            :items="formasTrabalhoList"
                            :search="search"
                            class="elevation-1"
                            :loading="loading"
                            loading-text="Carregando..."
                        >
                            <template v-slot:[`item.Afastamento`]="{ item }">
                              <div>
                                <div class="pt-1 pb-1">
                                  <v-chip v-if="item.Afastamento==1" color="orange" class="mr-1" dark>Afastado</v-chip>
                                  <v-chip v-else color="green" class="mr-1" dark>Ativo</v-chip>
                                  <v-chip v-if="item.IdPeriodo == 1" color="blue white--text" class="ml-1">{{item.Periodo}}</v-chip>
                                  <v-chip v-else-if="item.IdPeriodo == 2" color="orange white--text" class="ml-1">{{item.Periodo}}</v-chip>
                                  <v-chip v-else color="black white--text" class="ml-1">{{item.Periodo}}</v-chip>
                                </div>
                              </div>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ onn, attrss }">
                                  <v-menu v-bind="attrss" v-on="onn" :close-on-content-click="false" top offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn color="primary"  dark v-bind="attrs" icon v-on="on">
                                        <v-icon>mdi-format-list-checkbox</v-icon>
                                      </v-btn>
                                    </template>
                                    <v-list>
                                      <v-list-item>
                                        <v-list-item-title>
                                          <v-checkbox v-model="item.Segunda" label="Segunda" readonly></v-checkbox>
                                          <v-checkbox v-model="item.Terca" label="Terça" readonly></v-checkbox>
                                          <v-checkbox v-model="item.Quarta" label="Quarta" readonly></v-checkbox>
                                          <v-checkbox v-model="item.Quinta" label="Quinta" readonly></v-checkbox>
                                          <v-checkbox v-model="item.Sexta" label="Sexta" readonly></v-checkbox>
                                          <v-checkbox v-model="item.Sabado" label="Sábado" readonly></v-checkbox>
                                          <v-checkbox v-model="item.Domingo" label="Domingo" readonly></v-checkbox>
                                        </v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                </template>
                                <span>dias de atendimento</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" icon @click="[AgendamentoCredenciadoList=[] ,AgendamentoCredenciado(item), dialogAgendamentos = true]">
                                    <v-icon color="primary"> mdi-calendar-range </v-icon>
                                  </v-btn>
                                </template>
                                <span>Agendamentos já realizados</span>
                              </v-tooltip>
                                <v-tooltip v-if="item.Afastamento==1" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" icon @click="[retornarProfissional(item)]">
                                            <v-icon color="green">mdi-account-arrow-left</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>cancelar afastamento</span>
                                </v-tooltip>
                                <v-tooltip v-else bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" icon @click="[getDatasFormaTrabalho(item), dialogAfastarProfissional = true]">
                                            <v-icon>mdi-account-arrow-right</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>afastar credenciado</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" icon @click="[getFormaTrabalho(item), getIdFormaTrabalhoAtual(item)]">
                                            <v-icon color="orange">mdi-calendar-edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>editar forma de trabalho</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" icon @click="[deleteFormaTrabalho(item)]">
                                            <v-icon color="red">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>excluir forma de trabalho</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>

        <!--      Dialog para agendamentos marcados-->
              <v-dialog width="60%" v-model="dialogAgendamentos">
                <v-card>
                  <v-card-title>Agendamentos já realizados para o credenciado</v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-data-table
                        :headers="headersAgendamentoCredenciado"
                        :items="AgendamentoCredenciadoList"
                        class="elevation-1"
                        loading-text="Carregando..."
                    >
                      <template v-slot:[`item.dataInicial`]="{ item }">
                        {{ $moment(item.dataInicial).format("L") }}
                      </template>

                    </v-data-table>
        <!--            <v-chip v-for="Credenciado in AgendamentoCredenciadoList" :key="Credenciado.index" color="primary">{{Credenciado.titulo}}</v-chip>-->
                  </v-card-text>
                </v-card>
              </v-dialog>

            <v-dialog width="50%" v-model="dialogAfastarProfissional">
                <v-card>
                    <v-card-title>Informar afastamento do credenciado</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-col
                          class="px-2 py-0 ma-0"
                      >
                        <v-alert
                            v-if="system.alertError"
                            v-model="system.alertError"
                            dismissible
                            type="error">
                          <ul>
                            <li v-for="error in system.alertInfo" :key="error.index">{{error}}</li>
                          </ul>
                        </v-alert>
                      </v-col>

                    <v-row>
                        <v-col cols="6">
                        <v-menu
                            v-model="system.menuAfastamentoDataInicial"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dataInicialAfastamento"
                                label="Data Inicial"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                type="date"
                            ></v-text-field>
                            </template>
                            <v-date-picker
                                :min="today"
                                v-model="dataInicialAfastamento"
                                @input="system.menuAfastamentoDataInicial = false">
                            </v-date-picker>
                        </v-menu>
                        </v-col>
                        <v-col cols="6">
                        <v-menu
                            v-model="system.menuAfastamentoDataFinal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dataFinalAfastamento"
                                label="Data Final"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                type="date"
                            ></v-text-field>
                            </template>
                            <v-date-picker :min="dataInicialAfastamento" v-model="dataFinalAfastamento" @input="system.menuAfastamentoDataFinal = false"></v-date-picker>
                        </v-menu>
                        </v-col>
                    </v-row>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                            @click="[afastarProfissionalData()]"
                            dark
                    >
                        Registrar afastamento
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- CADASTRO DA FORMA DE TRABALHO -->
            <v-dialog scrollable v-model="dialogCadFormaTrabalho" width="80%">
                <v-card>
                    <v-card-title>Nova forma de trabalho</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-alert v-if="system.alertError" v-model="system.alertError" dismissible type="error">
                                    <ul>
                                        <li v-for="error in system.alertInfo" :key="error.index">{{error[0]}}</li>
                                    </ul>
                                </v-alert>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-autocomplete :loading="loading" 
                                        v-model="cadastro.IdProfissional" 
                                        :items="credenciadosList" 
                                        item-text="Nome" 
                                        item-value="IdProfissional" 
                                        label="Credenciado" 
                                        required
                                        :rules="[rules.required]"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-autocomplete :loading="loading" v-model="cadastro.IdUnidade" :items="unidadesList" item-text="Unidade" item-value="IdUnidade" label="Unidade" required
                                        :rules="[rules.required]"></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-autocomplete :loading="loading" v-model="cadastro.IdEspecialidade" :items="especialidadesList" item-text="Especialidade" item-value="IdEspecialidade" label="Especialidade" required
                                        :rules="[rules.required]"></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-autocomplete :loading="loading" v-model="cadastro.IdPeriodo" :items="periodosList" item-text="Periodo" item-value="IdPeriodo" label="Período" required
                                        :rules="[rules.required]"></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-menu
                                    v-model="system.menuDataInicial"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="cadastro.DataInicial"
                                        label="Data Inicial"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        type="date"
                                        :loading="loading"
                                        required
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="cadastro.DataInicial" @input="[system.menuDataInicial = false]"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="4">
                                <v-menu
                                    v-model="system.menuDataFinal"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="cadastro.DataFinal"
                                            label="Data Final"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="cadastro.dataInicial == ''"
                                            type="date"
                                            :loading="loading"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker :min="cadastro.DataInicial" v-model="cadastro.DataFinal" @input="system.menuDataFinal = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12">
                                <h4>Dias de atendimento</h4>
                                <v-row>
                                    <v-col cols="1" class="mr-4">
                                        <v-checkbox v-model="cadastro.Segunda" label="Segunda"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="cadastro.Terca" label="Terça"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="cadastro.Quarta" label="Quarta"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="cadastro.Quinta" label="Quinta"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="cadastro.Sexta" label="Sexta"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1" class="mr-2">
                                        <v-checkbox v-model="cadastro.Sabado" label="Sábado"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="cadastro.Domingo" label="Domingo"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialogCadFormaTrabalho = !dialogCadFormaTrabalho" large dark>cancelar</v-btn>
                        <v-btn :loading="loading" @click="cadFormaTrabalho()" color="primary" large dark>cadastrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- ATUALIZA DA FORMA DE TRABALHO -->
            <v-dialog scrollable v-model="dialogAttFormaTrabalho" width="80%">
                <v-card>
                    <v-card-title>Atualizar forma de trabalho</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-alert v-if="system.alertError" v-model="system.alertError" dismissible type="error">
                                    <ul>
                                        <li v-for="error in system.alertInfo" :key="error.index">{{error[0]}}</li>
                                    </ul>
                                </v-alert>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-autocomplete :loading="loading" v-model="atualiza.IdProfissional" :items="credenciadosList" item-text="Nome" item-value="IdProfissional" label="Credenciado"></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-autocomplete :loading="loading" v-model="atualiza.IdUnidade" :items="unidadesList" item-text="Unidade" item-value="IdUnidade" label="Unidade"></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-autocomplete :loading="loading" v-model="atualiza.IdEspecialidade" :items="especialidadesList" item-text="Especialidade" item-value="IdEspecialidade" label="Especialidade"></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-autocomplete :loading="loading" v-model="atualiza.IdPeriodo" :items="periodosList" item-text="Periodo" item-value="IdPeriodo" label="Periodo"></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-menu
                                    v-model="system.menuDataInicial"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="atualiza.DataInicial"
                                        label="Data Inicial"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        type="date"
                                        :loading="loading"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="atualiza.DataInicial" @input="[system.menuDataInicial = false]"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="4">
                                <v-menu
                                    v-model="system.menuDataFinal"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="atualiza.DataFinal"
                                            label="Data Final"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="atualiza.dataInicial == ''"
                                            type="date"
                                            :loading="loading"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker :min="atualiza.DataInicial" v-model="atualiza.DataFinal" @input="system.menuDataFinal = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12">
                                <h4>Dias de atendimento</h4>
                                <v-row>
                                    <v-col cols="1" class="mr-4">
                                        <v-checkbox v-model="atualiza.Segunda" label="Segunda"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="atualiza.Terca" label="Terça"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="atualiza.Quarta" label="Quarta"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="atualiza.Quinta" label="Quinta"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="atualiza.Sexta" label="Sexta"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1" class="mr-2">
                                        <v-checkbox v-model="atualiza.Sabado" label="Sábado"></v-checkbox>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-checkbox v-model="atualiza.Domingo" label="Domingo"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialogAttFormaTrabalho = !dialogAttFormaTrabalho" large dark>cancelar</v-btn>
                        <v-btn :loading="loading" @click="updateFormaTrabalho()" color="primary" large dark>atualizar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <AlertSystem :snackbar="system.snackbar"></AlertSystem>
            </v-container>
    </v-form>
</template>

<script>
import AlertSystem from '../components/AlertSystem.vue'
import moment from 'moment'
export default {
    name: "FormaTrabalho",
    components: {
        AlertSystem
    },
    data: () => ({
        system: {
            snackbar: {},
            alertInfo: [],
            alertError: false,
            menuDataInicial: false,
            menuAfastamentoDataInicial: false,
            menuDataFinal: false,
            menuAfastamentoDataFinal: false
        },
        formValid: false,
        rules: {
            required: value => !!value || 'O preenchimento é obrigatório',
        },
        headers: [
            { text: 'Credenciado', value: 'Nome', width: '20%'},
            { text: 'Especialidade', value: 'Especialidade', width: '20%'},
            { text: 'Unidade', value: 'Unidade', width: '15%'},
            { text: 'CPF', value: 'CPF'},
            { text: 'Situação', value: 'Afastamento', align: 'center', width: '20%'},
            { text: 'Ações', value: 'actions', align:'right', width: '12.5%'},
        ],
        headersAgendamentoCredenciado:[
          {text: 'Titulo', value: 'titulo'},
          {text: 'Unidade', value:'Unidade'},
          {text: 'Data Inicial', value: 'dataInicial'}
        ],
        dynamicCol: 3,
        formasTrabalhoList: [],
        credenciadosList: [],
        especialidadesList: [],
        unidadesList: [],
        periodosList: [],
        dataInicialAfastamento: '',
        dataFinalAfastamento: '',
        search: '',
        loading: false,
        dialogCadFormaTrabalho: false,
        dialogAttFormaTrabalho: false,
        dialogAfastarProfissional: false,
        dialogAgendamentos: false,
        IdFormaTrabalho: '',
        IdUnidadeSelecionado:'',
        AgendamentoCredenciadoList:[],
        IdEspecialidadeSelecionada: null,
        IdPeriodoSelecionada: null,
        hoje: null,
        today:null,
        cadastro: {
            IdProfissional: null,
            IdEspecialidade: null,
            IdUnidade: null,
            IdPeriodo: null,
            DataInicial: null,
            DataFinal: null,
            Segunda: 0,
            Terca: 0,
            Quarta: 0,
            Quinta: 0,
            Sexta: 0,
            Sabado: 0,
            Domingo: 0,
        },
        atualiza: {}
    }),
    methods: {
        resetData () {
            Object.assign(this.$data, this.$options.data.call(this))
            this.getAllData()
        },
        getIdFormaTrabalhoAtual (item) {
            this.IdFormaTrabalho = item.IdFormaTrabalho
        },
        getEspecialidades () {
            return this.axios('especialidades')
        },
        getCredenciados () {
            return this.axios('credenciados')
        },
        getUnidades () {
            return this.axios('unidades')
        },
        getPeriodos () {
            return this.axios('periodos')
        },
        getFormasTrabalho () {
            return this.axios('formas', {
              params:{
                IdUnidade: this.IdUnidadeSelecionado,
                IdEspecialidade: this.IdEspecialidadeSelecionada,
                IdPeriodo: this.IdPeriodoSelecionada,
              }
            })
        },
        cadFormaTrabalho () {
            if (!this.$refs.formDados.validate())
                return false
            this.loading = true
            this.axios.post('formas', { cadastro: this.cadastro }).then(res => {
                this.formasTrabalhoList = res.data
                this.system.snackbar = {
                    snackbar: true,
                    text: res.data,
                    color: "green",
                };
                this.dialogCadFormaTrabalho = false
                this.resetData()
            }).catch( error => {
                this.system.alertError = true
                this.system.alertInfo = error.response.data
            }).finally( () => {
                this.loading = false
            })
        },
        updateFormaTrabalho () {
            if (!this.$refs.formDados.validate())
                return false
            this.loading = true
            this.axios.put(`formas/${this.IdFormaTrabalho}`, { atualiza: this.atualiza }).then(res => {
                this.formasTrabalhoList = res.data
                this.resetData()
            }).catch( error => {
                this.system.alertError = true
                this.system.alertInfo = error.response.data
            }).finally( () => {
                this.loading = false
            })
        },
        deleteFormaTrabalho (formaTrabalho) {
            let del = confirm("Deseja realmente excluir essa forma de trabalho?");
            if (del) {
                this.axios.delete(`formas/${formaTrabalho.IdFormaTrabalho}`).then( res => {
                    this.system.snackbar = {
                        snackbar: true,
                        text: res.data,
                        color: "green",
                    };
                    this.resetData()
                }).catch( error => {
                    this.system.snackbar = {
                        snackbar: true,
                        text: error.response.data,
                        color: "red",
                    };
                })
            }
        },
        getFormaTrabalho (item) {
            this.axios(`formas/${item.IdFormaTrabalho}`).then( res => {
                this.atualiza = res.data[0]
                this.dialogAttFormaTrabalho = true
            })
        },
        AgendamentoCredenciado(item){
            this.axios(`credenciados/${item.IdProfissional}/Agendamentos`).then(res => {
                this.AgendamentoCredenciadoList = res.data;
            })
        },
        getDatasFormaTrabalho (item) {
            this.IdFormaTrabalho = item.IdFormaTrabalho
            this.dataInicialAfastamento = moment(item.DataInicialAfastamento).format('YYYY-MM-DD')
            this.dataFinalAfastamento = moment(item.DataFinalAfastamento).format('YYYY-MM-DD')
            if(item.DataInicialAfastamento == null){
              this.dataInicialAfastamento = ''
            }
            if(item.DataFinalAfastamento == null){
              this.dataFinalAfastamento = ''
            }
        },
        retornarProfissional (item) {
            this.axios.patch(`formas/${item.IdFormaTrabalho}`).then( res => {
                this.system.snackbar = {
                snackbar: true,
                text: res.data,
                color: "green",
                };                
                this.dialogAfastarProfissional  = false
                setTimeout(() => {
                    this.resetData()
                }, 2000)
            }).catch(error => {
                this.system.alertError = true
                this.system.alertInfo = error.response.data
            }).finally(() => {
                this.loading = false
            })
        },
        afastarProfissionalData () {
          this.axios.patch(`formas/${this.IdFormaTrabalho}/datas`, {
            datainicial: this.dataInicialAfastamento + ' 00:00:00',
            datafinal: this.dataFinalAfastamento + ' 23:59:59'
          }).then( res => {
            this.system.snackbar = {
              snackbar: true,
              text: res.data,
              color: "green",
            };
            this.dialogAfastarProfissional = false
            this.getAllData()
          }).catch( error => {
                this.system.alertError = true
                this.system.alertInfo = error.response.data
          }).finally( () => {
            this.loading = false
          })
        },
        limparFiltros() {
           this.IdEspecialidadeSelecionada      = null;
           this.IdUnidadeSelecionado            = null;
           this.IdPeriodoSelecionada            = null;
           this.search                          = '';           
        },
        now(){
          this.today = moment().format('YYYY-MM-DD');
        },
        getAllData () {
            this.loading = true
            Promise.all([
                this.getFormasTrabalho(),
                this.getCredenciados(),
                this.getUnidades(),
                this.getEspecialidades(),
                this.getPeriodos()
            ]).then( responses => {
                this.formasTrabalhoList = responses[0].data.filter(element => {
                  element.Nome = this.prepareNameFilter(element.Nome);
                  element.Especialidade = this.prepareNameFilter(element.Especialidade)
                  return element;
                })
                this.credenciadosList = responses[1].data.map(element => {
                  element.Nome = this.prepareNameFilter(element.Nome);
                    return {
                        IdProfissional: element.IdProfissional,
                        Nome: `${element.Nome} - (${element.CPF})`
                    }
                })
                this.unidadesList = responses[2].data
                this.especialidadesList = responses[3].data.filter(element => {
                  element.Especialidade = this.prepareNameFilter(element.Especialidade);
                  return element;
                })
                this.periodosList = responses[4].data
            }).finally( () => {
                this.loading = false
            })
        }
    },
    mounted () {
        this.getAllData()
        this.now()
        this.$refs.formDados.validate()
    }
}
</script>

<style scoped>

</style>